import { showSSOButtons } from "@faire/deprecated-retailer-visitor-shared/lib/ssoUtils";
import { getDocument } from "@faire/web/common/globals/getDocument";
import { loadScript } from "@faire/web/common/loadScript";

const GOOGLE_LOGIN_SCRIPT_NAME = "_googleLogin";
const GOOGLE_LOGIN_SCRIPT_SRC = "https://accounts.google.com/gsi/client";

export const isGoogleLoginSciptLoaded = () =>
  !!getDocument()?.getElementById(GOOGLE_LOGIN_SCRIPT_NAME);

export const loadGoogleLoginScript = async () => {
  if (!isGoogleLoginSciptLoaded() && showSSOButtons()) {
    await loadScript(GOOGLE_LOGIN_SCRIPT_SRC, GOOGLE_LOGIN_SCRIPT_NAME);
  }
};
